<template>
  <div>
    <img src="@/assets/total_value_icon.png" />
    <h2 class="title is-uppercase">Total Value</h2>
    <div>
      <font-awesome-icon :icon="[ 'far', 'arrow-alt-circle-up']" size="3x" /><span class="indicator-value"><vue-numeric v-bind:read-only=true currency="$" v-bind:precision=0 v-bind:value="getTotalValueIndicatorAmount"></vue-numeric></span>
    </div>
    <div class="columns">
      <div class="thickdivider"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import VueNumeric from 'vue-numeric'

export default {
  data () {
    return {
    }
  },
  components: {
    VueNumeric
  },
  computed: {
    ...mapGetters([
      'getTotalValueIndicatorAmount'
    ])
  }
}
</script>

<style scoped>
.title {
  font-size: 1.5em;
}
.indicator-value {
  font-size: 1.5em;
  margin-left: 10px;
}
</style>
